<template>
  <el-dialog :title="$t('declaracao-conteudo')" :visible.sync="dialog" :fullscreen="true" :close-on-click-modal="false">
    <el-form :model="form">
      <el-row :gutter="5">
        <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
          <el-form-item :label="$t('descricao')">
            <el-input v-model="form.content" maxlength="100"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
          <el-form-item :label="$t('quantidade')">
            <el-input type="number" v-model="form.quantity" maxlength="5"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="5" :xl="7">
          <el-form-item :label="$t('valor')">
            <el-input type="number" v-model="form.value" maxlength="10">
              <el-button slot="append" type="default" @click="add()">Adicionar</el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table :data="tableData" stripe ref="tableDc" style="width: 100%"
      :default-sort="{ prop: 'content', order: 'ascending' }">
      <el-table-column prop="content" :label="$t('descricao')">
      </el-table-column>
      <el-table-column prop="quantity" :label="$t('quantidade')"></el-table-column>
      <el-table-column prop="value" :label="$t('valor')">
        <template slot-scope="scope">{{
          scope.row.value
          | currency("R$ ", 2, {
            thousandsSeparator: ".",
            decimalSeparator: ",",
          })
        }}</template>
      </el-table-column>

      <el-table-column label="#" width="180">
        <template slot-scope="scope">
          <el-button type="danger" icon="el-icon-delete" @click="remove(scope.row.item)" circle></el-button>
        </template>
      </el-table-column>
    </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="save()">Salvar</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: "PrePostDC",
  methods: {
    open() {
      this.dialog = true;
    },
    add() {
      const vm = this;
      if (!vm.form.content) {
        return vm.$message({
          type: "error",
          message: "Informe uma descrição!",
        });
      }
      const q = +vm.form.quantity;
      if (isNaN(q) || q <= 0) {
        return vm.$message({
          type: "error",
          message: "Informe uma quantidade valida!",
        });
      }
      const v = +vm.form.value;
      if (isNaN(v) || v <= 0) {
        return vm.$message({
          type: "error",
          message: "Informe um valor valido!",
        });
      }
      vm.tableData.push({ ...vm.form });
      vm.form.content = "";
      vm.form.value = 0;
      vm.form.quantity = 0;
      vm.form.item++;
    },
    remove(item) {
      const vm = this;
      vm.tableData.splice(
        vm.tableData.findIndex((x) => x.item == item),
        1
      );
    },
    clear() {
      const vm = this;
      vm.tableData = [];
    },
    save() {
      const vm = this;
      this.dialog = false;
      vm.$emit("saved", vm.tableData);
    },
  },
  data() {
    return {
      tableData: [],
      dialog: false,
      form: {
        item: 1,
        content: "",
        quantity: 0,
        value: 0,
      },
    };
  },
};
</script>
